import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";

export interface Remove2FAUseCaseResult {
  success: boolean;
  error?: string;
}

export const remove2FAUseCase = async (
  userId,
): Promise<Remove2FAUseCaseResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;

    await apiUseCases.postRemove2FA(namespace, userId);

    return {
      success: true,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(
        error,
        "Failed to remove 2FA. Please try again later.",
      ).message,
    };
  }
};
